





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BaseModal extends Vue {
    @Prop({required: false, default: () => null}) closeRoute!: any;

    get actualCloseRoute() {
        if (this.closeRoute != null) {
            return this.closeRoute;
        }

        return this.$route.matched[this.$route.matched.length - 2];
    }
}
